<template>
  <div
    class="hamburger animated opa-0"
    @click="hideMenu"
    v-if="isVisible"
    :class="{'fadeIn': isVisible}"
  >
    <router-link class="hamburger__link" to="/">{{ $t("home") }}</router-link>
    <router-link class="hamburger__link" to="/about">{{ $t("about") }}</router-link>
    <router-link class="hamburger__link" to="/gallery">{{ $t("gallery") }}</router-link>
    <router-link class="hamburger__link" to="/contact">{{ $t("contact") }}</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      done: false
    };
  },
  methods: {
    hideMenu() {
      return this.$store.dispatch("hideMenu");
    }
  },
  computed: {
    isVisible() {
      return this.$store.state.menuVisible;
    }
  },
  beforeCreate() {
    this.done = true;
    return;
  }
};
</script>

<style lang="scss" scoped>
.hamburger {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  z-index: 11;
  animation-duration: 400ms;
  background-color: rgba(255, 255, 255, 0.96);
  @include flex(center, center, column);
  &__link {
    margin-bottom: 4rem;
    margin-top: 4rem;
    color: $fonts;
    font-size: $font-size-big;
    padding-bottom: 1rem;
    transition: 200ms;
    @include respond(tab-land) {
      margin-bottom: 3rem;
      margin-top: 3rem;
    }
  }
}
.router-link-exact-active {
  border-bottom: 2px solid $fonts;
}
</style>